module.exports = __webpack_public_path__ + "img/donate-alipay-20.67e59873.png";